<template>
  <b-modal
    :id="id"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <template #modal-title>
      <span v-if="model">
        {{ model.name }}
        <small class="text-muted">#{{ model.id }}</small>
      </span>
    </template>

    <b-form-group :label="placeholder" class="w-75">
      <treeselect
        id="tags-treeselect"
        :options="tagOptions"
        :placeholder="placeholder"
        multiple
        v-model="tag_names"
        :disabled="busy"
      >
        <label slot="option-label" slot-scope="{node, labelClassName}" :class="labelClassName">
          <b-row>
            <b-col @click.self.stop.prevent>
              {{ node.label }}
            </b-col>
            <b-col class="col-auto">
              <b-button variant="link" size="sm" class="py-0" @mousedown.stop.prevent @click="onModifyTag(node)">
                <i class="fa fa-fw fa-edit"></i>
              </b-button>
            </b-col>
          </b-row>
        </label>
        <div v-if="showAdd" slot="after-list" class="text-right">
          <b-button variant="link" class="pl-0" @click="onClickAdd" >
            <small>
              <i class="fa fa-fw fa-plus"></i>
              {{ trans('create') }}
            </small>
          </b-button>
        </div>
      </treeselect>
      <create-tag-modal
        :organization="organization"
        :label="label"
        :initial-name="query"
        :type="type"
        @created="onTagCreated"
      ></create-tag-modal>
      <modify-tag-modal
        :organization="organization"
        :label="label"
        :type="type"
        :tag="tag"
        @saved="onTagModified"
      ></modify-tag-modal>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import CreateTagModal from './CreateTagModal'
  import ModifyTagModal from './ModifyTagModal'

  export default {
    props: {
      organization: Object,
      model: Object,
      id: {
        type: String,
        default: 'tags-modal',
      },
      attribute: {
        type: String,
        default: 'tags',
      },
      type: String,
      allTags: Array,
      showAdd: {
        type: Boolean,
        default: true,
      },
      placeholder: {
        type: String,
        default: trans('tags'),
      },
      label: {
        type: String,
        default: 'tag',
      },
    },
    components: {
      Treeselect,
      CreateTagModal,
      ModifyTagModal,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        tag_names: [],
        all_tags: _.cloneDeep(this.allTags),
        tag: null,
        query: null,
      }
    },
    computed: {
      tagOptions() {
        return _.map(this.all_tags || this.tag_names, tag => {
          return {
            id: tag.name || tag,
            label: tag.name || tag,
            tag_id: tag.id || null
          }
        })
      },
    },
    methods: {
      onModifyTag(node) {
        this.tag = _.find(this.all_tags, {id: node.raw.tag_id})
        this.$bvModal.show('modify-tag-modal')
      },
      onTagModified(tag) {
        _.each(this.all_tags, t => {
          if (t.id == tag.id) {
            let i = this.tag_names.indexOf(t.name)
            if (i >= 0) this.tag_names.splice(i, 1, tag.name)
            t.name = tag.name
          }
        })
        this.syncTags()
      },
      onTagCreated(tag) {
        this.all_tags.push(tag)
        this.tag_names.push(tag.name)
        this.syncTags()
      },
      syncTags() {
        this.all_tags = _.sortBy(this.all_tags, 'slug')
        this.$emit('all-tags', this.all_tags)
      },
      onShown() {
        this.all_tags = _.cloneDeep(this.allTags)
        this.tag_names = _.map(this.model[this.attribute], 'name')
        this.busy = false
        this.error = false
        if (!this.all_tags) this.loadAllTags()
      },
      loadAllTags() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/tags`
        if (this.type) url += '?type=' + this.type
        axios.get(url)
        .then(response => {
          this.busy = false
          this.all_tags = response.data
          this.$emit('all-tags', this.all_tags)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/${this.type}/${this.model.id}/tags`
        axios.patch(url, {
          tags: this.tag_names,
        })
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide(this.id ? this.id : 'tags-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClickAdd() {
        this.query = document.querySelector('#tags-treeselect input.vue-treeselect__input').value
        setTimeout(() => {
          this.$bvModal.show('create-tag-modal')
        }, 50)
      },
      onKeyDown(e) {
        // This is the only way we found to catch a user hitting Enter
        // Allows us to open the modal and add a value based on what they typed
        if (e.keyCode != 13) return
        let el = document.querySelector(`#${this.id} .vue-treeselect input.vue-treeselect__input`)
        if (!e.target.isSameNode(el)) return
        if (el.value) {
          e.stopImmediatePropagation()
          this.onClickAdd()
          return false
        }
      },
    },
    mounted() {
      window.tagsModal = this
      if (this.showAdd)
        document.addEventListener('keydown', this.onKeyDown, true)
    },
    destroyed() {
      if (this.showAdd)
        document.removeEventListener('keydown', this.onKeyDown, true)
    },
  }
</script>
